import { type AppNode } from '../types';

/**
 * Extracts video node data for sync. Backend uses media.original for video URLs.
 */
export function getVideoNodeData(node: AppNode) {
  if (node.type !== 'video') {
    return undefined;
  }

  const { data } = node;

  if (!data.media?.original || !data.source) {
    return undefined;
  }

  return {
    fileName: data.fileName ?? '',
    media: { original: data.media.original },
    prompt: data.prompt,
    source: data.source,
    type: 'video' as const,
  };
}
